import { HealthDocument } from "../index"
import { FirestoreDataConverter, Timestamp } from "firebase/firestore"
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"

dayjs.extend(utc)
dayjs.extend(timezone)

export default {
    toFirestore: (health: HealthDocument) => ({
        ...health,
        timestamp: Timestamp.fromDate(health.timestamp.toDate()),
        ...(health.nextTimestamp && { nextTimestamp: Timestamp.fromDate(health.nextTimestamp.toDate()) }),
    }),
    fromFirestore: (snapshot, options) => {
        const health = snapshot.data(options)
        return {
            id: snapshot.id,
            status: health.status,
            timestamp: dayjs(health.timestamp.toDate()).tz("Europe/Amsterdam"),
            ...(health.nextTimestamp && { nextTimestamp: dayjs(health.nextTimestamp.toDate()).tz("Europe/Amsterdam") }),
            battery: health.battery,
            charging: health.charging,
            storage: health.storage,
            temp: health.temp,
            ...(health.nextStartup && { nextStartup: dayjs(health.nextStartup.toDate()).tz("Europe/Amsterdam") }),
            ...(health.nextShutdown && { nextShutdown: dayjs(health.nextShutdown.toDate()).tz("Europe/Amsterdam") }),
            version: health.version,
            semver_version: health.version?.replace(/([0-9]+\.[0-9]+\.[0-9]+).*/, "$1"),
            synced: health.synced,
            network: health.network,
        }
    },
} as FirestoreDataConverter<HealthDocument>
